<template>
    <div class="section-box countries-box" v-loading="loading">
        <div class="title-box">
            <div class="detail-title">创建原厂认证</div>
            <div class="save-box">
                <el-button type="primary" class="save" @click="submitForm()">确认</el-button>
            </div>
        </div>
        <el-row class="commonTitle"> 基本信息 </el-row>
        <div>
            <el-form :inline="true" ref="ruleForm" label-width="120px" label-position="left"
                :model="form" class="one-ruleForm">
                <el-form-item label="认证名称：" required>
                    <el-input size="medium" v-model.trim="form.authname" placeholder="请输入认证名称" maxlength="100"
                        style="width: 550px; margin-right: 80px"></el-input>
                </el-form-item>
                <el-form-item label="认证品牌：" required>
                    <el-select 
                        size="medium" 
                        v-model="form.brandId" 
                        filterable
                        placeholder="请选择品牌" 
                        style="width: 550px;margin-right: 80px" 
                    >
                        <el-option 
                            v-for="(item, index) in brandArr" 
                            :value="item.key" 
                            :label="item.value"
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="认证领域：" required>
                    <el-select 
                        size="medium" 
                        v-model="form.domainId" 
                        multiple
                        filterable 
                        placeholder="请选择领域"
                        style="width: 550px; margin-right: 80px" 
                        @change="getProductSelectByDomains"
                        @remove-tag="form.productId=[]"
                    >
                        <el-option 
                            v-for="(item, index) in dominArr"
                            :value="item.domainid+''" 
                            :label="item.domainname" 
                            :key="index"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="认证产品：" required>
                    <el-select size="medium" 
                        v-model="form.productId" 
                        multiple 
                        filterable 
                        placeholder="请选择产品"
                        style="width: 550px; margin-right: 80px"
                    >
                        <el-option 
                            v-for="(item, index) in productSelectArr"
                            :value="item.key" 
                            :label="item.value" 
                            :key="index"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间：" required>
                    <el-date-picker
                        size="medium" 
                        v-model="form.starttime"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 550px; margin-right: 80px"
                        :picker-options="startOptions()"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间：" required>
                    <el-date-picker
                        size="medium" 
                        v-model="form.endtime"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 550px; margin-right: 80px"
                        :picker-options="endOptions()"
                    >
                    </el-date-picker>
                </el-form-item>
            </el-form>
        </div>

        <el-row class="commonTitle"><i style="color: red;margin-left: -10px;">*</i> 关联考试 </el-row>
        <div class="tableBox">
            <el-table border :data="listPaper" style="width: 100%">
                <el-table-column label="考试编号" prop="paperNo" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.spaperNo || "--" }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="考试名称" prop="paperName" width="600">
                    <template slot-scope="scope">
                        <span>{{ scope.row.spaperName || "--" }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="考试类别" prop="paperType">
                    <template slot-scope="scope">
                        <!-- <span>{{ scope.row.npaperAttribute == 1 ? "认证考试" : "课程考试" }}</span> -->
                        <span v-text="paperCategoryFun(scope.row.npaperCategory)"></span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button 
                            v-if="scope.$index != listPaper.length - 1"
                            size="mini" 
                            @click="handleDown(scope.$index, listPaper, 'test')">下移
                        </el-button>
                        <el-button 
                            size="mini" 
                            v-if="scope.$index != 0"
                            @click="handleUp(scope.$index, listPaper, 'test')">上移
                        </el-button>
                        <el-button type="danger" size="mini" @click="deleteTest(scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="addCourse" @click="addTestBtn()">添加考试</div>
        </div>
        <el-row class="commonTitle"> 宣传样式 </el-row>
        <div class="uploadBox">
            <div class="upload1">
                <div class="tit">封面图：</div>
                <div>
                    <el-upload class="show" 
                        :class="{ hide: hideUploadCover }" 
                        :action="url" 
                        list-type="picture-card"
                        :limit="1" 
                        :file-list="fileListCover" 
                        :on-change="dealImgChangeCover"
                        :on-remove="handleDealImgRemoveCover" 
                        :on-success="handleAvatarSuccessCover"
                        :on-preview="handlePictureCardPreview" 
                        accept=".jpg, .jpeg, .png"
                        :before-upload="uploadPreview">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <span class="tips">封面大小694*350,格式：gif/png/jpeg</span>
                </div>
            </div>
        </div>
        <div class="detailImg">
            <div class="tit">详情图：</div>
            <div>
                <el-upload 
                    class="show" 
                    :class="{ hide: hideUploadDetail }" 
                    :action="url" 
                    list-type="picture-card" 
                    :limit="1"
                    :file-list="fileListDetail" 
                    :on-change="dealImgChangeDetail" 
                    :on-remove="handleDealImgRemoveDetail"
                    :on-success="handleAvatarSuccessDetail" 
                    :on-preview="handlePictureCardPreview" 
                    accept=".jpg, .jpeg, .png">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <span class="tips"></span>
            </div>
        </div>

        <el-dialog title="请选择考试" :visible.sync="isTestPop" width="1200px" :before-close="handleCloseTest"
            :close-on-click-modal="false">
            <el-table border ref="testTable" :data="testTable" tooltip-effect="dark" style="width: 100%"
                @selection-change="handleSelectionChangeTest">
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column label="考试编号">
                    <el-table-column width="200">
                        <template slot="header" slot-scope="scope">
                            <i style="display: none">{{ scope.row }}</i>
                            <el-input size="mini" v-model="test.paperNo" placeholder="输入关键字搜索" @input="getExamList()" />
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.spaperNo || "--" }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="考试名称">
                    <el-table-column show-overflow-tooltip>
                        <template slot="header" slot-scope="scope">
                            <i style="display: none">{{ scope.row }}</i>
                            <el-input size="mini" v-model="test.name" placeholder="输入关键字搜索" @input="getExamList()" />
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.spaperName || "--" }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="考试分类">
                    <el-table-column show-overflow-tooltip>
                        <template slot="header">
                            <el-select v-model="test.paperName" placeholder="请选择" filterable size="mini"
                                @change="getExamList()">
                                <el-option value="" label="请选择"></el-option>
                                <el-option v-for="item in courseAttributeArr" :key="item.value" :label="item.value"
                                    :value="item.key">
                                </el-option>
                            </el-select>
                        </template>
                        <template slot-scope="scope">
                            <span v-text="paperAttributeFun(scope.row.npaperAttribute)"></span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="考试类别">
                    <el-table-column show-overflow-tooltip>
                        <template slot="header">
                            <el-select v-model="test.paperCategory" placeholder="请选择" filterable size="mini"
                                @change="getExamList()">
                                <el-option value="" label="请选择"></el-option>
                                <el-option v-for="item in paperCategoryArr" :value="item.key" :label="item.value"
                                    :key="item.value">
                                </el-option>
                            </el-select>
                        </template>
                        <template slot-scope="scope">
                            <span v-text="paperCategoryFun(scope.row.npaperCategory)"></span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="领域">
                    <el-table-column show-overflow-tooltip>
                        <template slot="header">
                            <el-select v-model="test.field" placeholder="请选择" filterable size="mini"
                                @change="getProductAndList(test.field, 'test')">
                                <el-option value="" label="请选择"></el-option>
                                <el-option v-for="(item, index) in dominArr" :value="item.domainid"
                                    :label="item.domainname" :key="index">
                                </el-option>
                            </el-select>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.sfield || "--" }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="产品">
                    <el-table-column show-overflow-tooltip>
                        <template slot="header">
                            <el-select v-model="test.product" placeholder="请选择" filterable size="mini"
                                @change="getExamList()">
                                <el-option value="" label="请选择"></el-option>
                                <el-option v-for="(item, index) in productSelectArr" :value="item.key"
                                    :label="item.value" :key="index">
                                </el-option>
                            </el-select>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.sproduct || "--" }}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="品牌">
                    <el-table-column show-overflow-tooltip>
                        <template slot="header">
                            <el-select v-model="test.brand" placeholder="请选择" filterable size="mini"
                                @change="getExamList()">
                                <el-option value="" label="请选择"></el-option>
                                <el-option v-for="(item, index) in brandArr" :value="item.key" :label="item.value"
                                    :key="index">
                                </el-option>
                            </el-select>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.sbrand || "--" }}
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
            <div class="pageLocation">
                <span>已选择{{ seletedCountTest }}条数据</span>
                <span>
                    <el-pagination :page-sizes="[10, 20, 50, 100, 200]" layout="total, sizes, prev, pager, next, jumper"
                        @size-change="testhandleSizeChange" @current-change="testhandleCurrentChange"
                        :current-page="test.pageNum" :total="test.total" :page-size="test.pageSize">
                    </el-pagination>
                </span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="testPushList()">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>
<script>
    import { mapActions } from "vuex";
    import {
        configDetails,          //获取信息
        configAddOrModi,        //国家认证 新增或修改
    } from "@/service/examination";
    import {
        dominList,
        courseTyeList,
        productSelectList,
        difficultyLevelList,
        brandList,
        authenticationList,
        industryList,
        chargeTypeList,
        matterTypeList,
        examList,
        courseAttribute,
        paperCategoryApi,
        mediaFormatList,
        productSelectByDomains,           //多领域下的产品
    } from "@/service/courseListApi";
    import apiEnv from "@/service/apiEnv.js";
    // import editor from "../../components/Editor/Editor";
    export default {
        //   components: { editor },
        data() {
            return {
                originTest: [],
                currentTest: {},
                selectedTest: {},
                form: {
                    authtype: this.$route.query.authtype,       //认证类型
                    id: '',             //新增不填 修改必填

                    authname: '',       //认证名称
                    authprice: '',      //认证价格
                    domainId: [],       //领域id
                    brandId: '',        //品牌id
                    productId: [],      //产品id
                    timelimit: '',      //时间限制
                    countlimit: '',     //次数限制
                    seconddiscount: '',     //优惠百分比
                    discountdaylimit: '',   //优惠天数
                    status: 1,              //状态
                    starttime: '',          //开始时间
                    endtime: '',            //结束时间
                },
                searchData:{},
                oraginForm:{},

                listPaper: [],
                isTestPop: false,
                test: {
                    paperNo: "",
                    name: "",
                    paperName: "",
                    paperCategory: "",
                    field: "",
                    product: "",
                    brand: "",
                    typeArr: [],
                    pageNum: 1,
                    pageSize: 10,
                    total: 0,
                },
                tableData2: [],
                multipleSelection: [],
                pkid: "",
                submitId: {},
                //下拉数组
                mediaFormatArr: [],
                chargeTypeArr: [],
                industryArr: [],
                authenticationArr: [],
                brandArr: [],
                difficultyLevelArr: [],
                dominArr: [],               //领域
                productSelectArr: [],       //产品
                courseTypeArr: [],
                matterTypeArr: [],
                courseAttributeArr: [],
                paperCategoryArr: [],
                url: apiEnv.uploadURL,
                testTable: [],
                //s上传
                hideUploadCover: false,
                fileListCover: [],
                dialogImageUrl: "",     //点击查看的url
                limitCount: 1,
                DialogsImageUrlCover: "",//封面图
                //e上传

                //s上传
                hideUploadDetail: false,
                fileListDetail: [],
                dialogVisible: false,
                DialogsImageUrlDetail: "", //详情图
                //e上传

                flageChangeWhList: "",
                seletedCountTest: 0,
                isPrice: false,
                lastPrice: 0,

                loading: false,
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (vm.$route.query.id !== 0) {
                    vm.init();
                    vm.getAllSelect();
                }
            });
        },
        beforeRouteLeave(to, from, next) {
            if (this.$route.query.id != 0 ) {
                this.resetAllFun();
                this.$refs.ruleForm.resetFields();
            }
            next()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.init();
            this.getAllSelect();
        },
        watch: {
        },
        methods: {
            ...mapActions('app', [
                'removeTabList'
            ]),
            // 调整顺序，arr 数组，indexAdd 添加元素的位置，indexDel 删除元素的位置（indexAdd与indexDel交换位置）
            handleChangeOrder(arr, indexAdd, indexDel, type) {
                arr[indexAdd] = arr.splice(indexDel, 1, arr[indexAdd])[0];
                if (type == "test") {
                    this.listPaper = arr;
                    return;
                }
            },
            // 上移，与前一个元素交换顺序
            handleUp(index, list, type) {
                if (index - 1 >= 0) {
                    this.handleChangeOrder(list, index, index - 1, type);
                } else {
                    this.$message.error("素材已经置顶，无法上移！");
                }
            },
            // 下移，与后一个元素交换顺序
            handleDown(index, list, type) {
                if (index + 1 < list.length) {
                    this.handleChangeOrder(list, index, index + 1, type);
                } else {
                    this.$message.error("素材已经置底，无法下移");
                }
            },
            // 考试
            handleSelectionChangeTest(arg) {
                for (var key in this.currentTest) {
                    const item = this.currentTest[key];
                    if (this.selectedTest[item.spaperNo])
                        delete this.selectedTest[item.spaperNo];
                }

                var count = 0;
                for (var idx in arg) {
                    const item = arg[idx];
                    this.selectedTest[item.spaperNo] = item;
                    if (this.selectedTest[item.spaperNo]) count++;
                }
                this.seletedCountTest = count;
            },
            // 点击添加关联考试
            testPushList() {
                this.listPaper = this.originTest;

                var cache = this.selectedTest;
                for (var idx in this.listPaper) {
                    const item = this.listPaper[idx];
                    cache[item.spaperNo] = item;
                }

                var new1 = [];
                for (var key in cache) {
                    const item1 = cache[key];
                    new1.push(item1);
                }

                this.listPaper = new1;

                this.currentTest = {};
                this.selectedTest = {};
                this.isTestPop = false;
            },
            deleteTest(idx) {
                this.listPaper.splice(idx, 1);
                this.$forceUpdate();
            },
            isNumType(n) {
                var nn = Number(n);
                if (!isNaN(nn)) {
                    return true;
                }
                return false;
            },
            submitForm(type) {
                const _this = this;
                let data =  Object.assign({}, this.form)
                if(!data.authname) {
                    return this.$message.error("请输入认证名称"); 
                }
                if(data.brandId === '') {
                    return this.$message.error("请选择品牌");
                }
                if(!data.domainId.length) {
                    return this.$message.error("请选择领取"); 
                }
                if(data.starttime === '') {
                    return this.$message.error("请选择开始时间"); 
                }
                if(data.endtime === '') {
                    return this.$message.error("请选择结束时间"); 
                }
                //考试 
                var arr1 = [];
                for (let i = 0; i < this.listPaper.length; i++) {
                    arr1.push(this.listPaper[i].spaperNo);
                }
                if (arr1.length <= 0) {
                    _this.loading = false;
                    this.$message.error("请添加关联考试");
                    return;
                }
                // E
                // 封面图
                if (!this.DialogsImageUrlCover) {
                    _this.loading = false;
                    this.$message.error("封面图未上传");
                    return;
                }
                if (!this.DialogsImageUrlDetail) {
                    _this.loading = false;
                    this.$message.error("详情图未上传");
                    return;
                }
                data.listPaperNo = arr1
                data.listimgurl = this.DialogsImageUrlCover;
                data.detailimgurl = this.DialogsImageUrlDetail;
                if(data.id == 0) {
                    data.status = 2
                }
                data.id == 0 && delete data.id
                data.brandId = [data.brandId]
                data.starttime = data.starttime + " 00:00:00";
                data.endtime = data.endtime + " 23:59:59";
                configAddOrModi(data).then(res=> {
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.resetAllFun()
                    this.$message.success('操作成功！')
                    setTimeout(() => {
                        this.removeTabList({
                            id: this.$route.meta.menuId,
                        })
                        this.$router.push(`/examination/originalList`);
                    }, 300)
                })
            },
            resetAllFun() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.listPaper = [];
                this.DialogsImageUrlCover = "";
                this.DialogsImageUrlDetail = "";
                this.fileListCover = [];
                this.fileListDetail = [];
                this.hideUploadCover = false;
                this.hideUploadDetail = false;
                this.lastPrice = "";
                this.originTest = [];
                this.productSelectArr = [];
            },
            //s上传
            uploadPreview(file) {
                let _this = this;
                const isSize = new Promise(function (resolve, reject) {
                    let width = 694; // 限制图片尺寸为654X270
                    let height = 350;
                    let _URL = window.URL || window.webkitURL;
                    let img = new Image();
                    img.onload = function () {
                        let valid = img.width === width && img.height === height;
                        valid ? resolve() : reject();
                    };
                    img.src = _URL.createObjectURL(file);
                }).then(
                    () => {
                        return file;
                    },
                    () => {
                        _this.$message.error("图片尺寸限制为694*350");
                        return Promise.reject();
                    }
                );
                return isSize;
            },
            dealImgChangeCover(file, fileList) {
                this.hideUploadCover = fileList.length >= this.limitCount;
            },
            //删除上传文件Cover
            handleDealImgRemoveCover(file, fileList) {
                this.hideUploadCover = fileList.length >= this.limitCount;
                this.fileListCover = fileList;
                this.DialogsImageUrlCover = "";
                //eslint-disable-next-line no-debugger
                debugger;
            },
            //上传成功Cover
            handleAvatarSuccessCover(res, file, fileList) {
                if (res.Result != 1) {
                    this.fileListCover = [];
                    return this.$message.error(res.Message);
                }
                this.fileListCover = fileList;
                this.DialogsImageUrlCover = res.Data[0].imgUrl;
                console.log(this.DialogsImageUrlCover);
            },
            //点击图片查看
            handlePictureCardPreview(file) {
                this.dialogImageUrl = "";
                this.dialogImageUrl = file.response ?
                    file.response.Data[0].imgUrl :
                    file.url;
                this.dialogVisible = true;
            },
            //e上传

            //s上传
            dealImgChangeDetail(file, fileList) {
                this.hideUploadDetail = fileList.length >= this.limitCount;
            },
            //删除上传文件Detail
            handleDealImgRemoveDetail(file, fileList) {
                this.hideUploadDetail = fileList.length >= this.limitCount;
                this.fileListDetail = fileList;
                this.DialogsImageUrlDetail = "";
                //eslint-disable-next-line no-debugger
                // debugger
            },
            //上传成功Detail
            handleAvatarSuccessDetail(res, file, fileList) {
                if (res.Result != 1) {
                    this.fileListDetail = [];
                    return this.$message.error(res.Message);
                }
                this.fileListDetail = fileList;
                this.DialogsImageUrlDetail = res.Data[0].imgUrl;
                console.log(this.DialogsImageUrlDetail);
            },
            //e上传
            testhandleSizeChange(val) {
                this.test.pageNum = 1;
                this.test.pageSize = val;
                this.getExamList();
            },
            testhandleCurrentChange(val) {
                this.test.pageNum = val;
                this.getExamList();
            },
            paperAttributeFun(id) {
                //1=认证考试，2=课程考试
                if (id == 1) {
                    return "认证考试";
                }
                if (id == 2) {
                    return "课程考试";
                }
                return "--";
            },
            paperCategoryFun(id) {
                if (id == 1) {
                    return "安全规范";
                }
                if (id == 2) {
                    return "能力测评";
                }
                if (id == 3) {
                    return "工艺";
                }
                return "--";
            },
            clearTest() {
                this.test = {
                    paperNo: "",
                    name: "",
                    paperName: "",
                    paperCategory: "",
                    field: "",
                    product: "",
                    brand: "",
                    pageNum: 1,
                    pageSize: 10,
                };
            },
            addTestBtn() {
                this.clearTest();
                for (var idx in this.listPaper) {
                    const item = this.listPaper[idx];
                    this.selectedTest[item.spaperNo] = item;
                }

                this.isTestPop = true;
                this.getExamList();
            },
            async getExamList() {
                const _this = this;

                var data = {
                    pageNum: this.test.pageNum,
                    pageSize: this.test.pageSize,
                    npublishStatus: 1,
                };
                var tempArr0 = [];
                var tempArr1 = [];
                if (_this.test.paperNo) data.spaperNo = _this.test.paperNo;
                if (_this.test.name) data.spaperName = _this.test.name;
                if (_this.test.paperName) data.npaperAttribute = _this.test.paperName;
                if (_this.test.paperCategory)
                    data.npaperCategory = _this.test.paperCategory;
                if (_this.test.field) {
                    tempArr0.push(this.test.field);
                    data.sfieldIds = tempArr0;
                }
                if (_this.test.product) {
                    tempArr1.push(this.test.product);
                    data.sproductIds = tempArr1;
                }
                if (_this.test.brand) data.sbrandId = _this.test.brand;
                let r = await examList(data);
                if (r.Result == 1) {
                    const old = JSON.parse(JSON.stringify(this.selectedTest));
                    this.currentTest = {};
                    for (var idx in r.Data.datas) {
                        const item = r.Data.datas[idx];
                        this.currentTest[item.spaperNo] = item;
                    }

                    this.testTable = r.Data.datas;
                    this.test.total = r.Data.total;
                    this.$forceUpdate();

                    if (Object.keys(old).length)
                        this.$nextTick(() => {
                            for (var idx1 in _this.testTable) {
                                const item1 = _this.testTable[idx1];
                                if (old[item1.spaperNo]) {
                                    _this.$refs.testTable.toggleRowSelection(item1);
                                }
                            }

                            for (var key1 in old) {
                                const item2 = old[key1];
                                _this.selectedTest[key1] = item2;
                            }

                            this.$forceUpdate();
                        });
                }
            },
            getProductAndList(id, type) {
                this.flageChangeWhList = type;
                this.form.productId=[]
                this.$nextTick(() => {
                    this.getProductSelectList(id);
                });
            },

            getAllSelect() {
                this.getChargeTypeList();
                this.getIndustryList();
                this.getAuthenticationList();
                this.getBrandList();
                this.getDifficultyLevelList();
                this.getProductSelectList();
                this.getCourseTypeList();
                this.getDominList();
                this.getMatterType();
                this.getCourseAttribute();
                this.paperCategoryApiFun();
                this.getMediaFormatList();
            },

            getMediaFormatList() {
                mediaFormatList().then((r) => {
                    if (r.Result == 1) {
                        this.mediaFormatArr = r.Data || [];
                    }
                });
            },
            paperCategoryApiFun() {
                paperCategoryApi().then((r) => {
                    if (r.Result == 1) {
                        this.paperCategoryArr = r.Data || [];
                    }
                });
            },
            getCourseAttribute() {
                courseAttribute().then((r) => {
                    if (r.Result == 1) {
                        this.courseAttributeArr = r.Data || [];
                    }
                });
            },
            getMatterType() {
                matterTypeList().then((r) => {
                    if (r.Result == 1) {
                        this.matterTypeArr = r.Data || [];
                    }
                });
            },
            getChargeTypeList() {
                chargeTypeList().then((r) => {
                    if (r.Result == 1) {
                        this.chargeTypeArr = r.Data || [];
                    }
                });
            },
            getIndustryList() {
                industryList().then((r) => {
                    if (r.Result == 1) {
                        this.industryArr = r.Data || [];
                    }
                });
            },
            getAuthenticationList() {
                authenticationList().then((r) => {
                    if (r.Result == 1) {
                        this.authenticationArr = r.Data || [];
                    }
                });
            },
            getBrandList() {
                brandList().then((r) => {
                    if (r.Result == 1) {
                        this.brandArr = r.Data || [];
                    }
                });
            },

            getDifficultyLevelList() {
                difficultyLevelList().then((r) => {
                    if (r.Result == 1) {
                        this.difficultyLevelArr = r.Data || [];
                    }
                });
            },
            getProductSelectList(id) {
                const _this = this;
                productSelectList(id).then((r) => {
                    if (r.Result == 1) {
                        _this.productSelectArr = r.Data || [];
                        _this.$forceUpdate();
                        if (this.flageChangeWhList == "test") {
                            _this.test.product = "";
                            this.getExamList();
                            return;
                        }
                    }
                });
            },
            // 多领域产品
            getProductSelectByDomains(){
                const _this = this;
                let data = this.form.domainId.toString()
                let productSelectId = this.form.productId
                this.form.productId=[];
                productSelectByDomains(data).then(r=> {
                    if (r.Result == 1) {
                        _this.productSelectArr = r.Data || [];
                        _this.productSelectArr.map(item=>{
                            productSelectId.filter(x=>{
                                if(item.key == x) {
                                    _this.form.productId.push(x)
                                }
                            })
                        })
                        _this.$forceUpdate();
                    }
                })
            },
            getCourseTypeList() {
                courseTyeList().then((r) => {
                    if (r.Result == 1) {
                        this.courseTypeArr = r.Data || [];
                    }
                });
            },
            getDominList() {
                dominList().then((r) => {
                    if (r.Result == 1) {
                        this.dominArr = r.Data || [];
                    }
                });
            },
            init() {
                this.form.id = this.$route.query.id;
                if (this.form.id != 0) {
                    this.getDetail();
                }
            },
            // 获取详情 (暂时修改)
            getDetail() {
                const _this = this;
                var data = {
                    id: this.form.id,
                };
                configDetails(data).then(res=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    var d = res.Data
                    if(d.domainIds instanceof Array && d.domainIds.length) this.getProductAndList(d.domainIds[0], 'mainForm');
                    _this.$nextTick(()=> {
                        _this.form.authname = d.authname
                        _this.form.authprice = d.authprice
                        _this.form.domainId = d.domainIds || []
                        _this.form.productId = d.productIds || []
                        _this.form.timelimit = d.timelimit
                        _this.form.countlimit = d.countlimit
                        _this.form.seconddiscount = d.seconddiscount
                        _this.form.discountdaylimit = d.discountdaylimit
                        _this.form.status = d.status
                        _this.listPaper = d.listAuthExamPaper || [];
                        _this.originTest = d.listAuthExamPaper || [];
                        _this.form.brandId = d.brandId || ''
                        _this.form.brandName = d.brandName || ''
                        _this.form.starttime = d.starttime.split(" ")[0]
                        _this.form.endtime = d.endtime.split(" ")[0]

                        let objCover = {};
                        let objDetail = {};
                        this.fileListCover = [];
                        this.fileListDetail = [];
                        if (d.listimgurl) {
                            objCover.url = d.listimgurl;
                            this.fileListCover.push(objCover);
                            this.hideUploadCover = true;
                            this.DialogsImageUrlCover = d.listimgurl;
                        }
                        if (d.detailimgurl) {
                            objDetail.url = d.detailimgurl;
                            this.fileListDetail.push(objDetail);
                            this.hideUploadDetail = true;
                            this.DialogsImageUrlDetail = d.detailimgurl;
                        }
                    })
                })
            },
            handleCloseTest() {
                this.currentTest = {};
                this.selectedTest = {};
                this.isTestPop = false;
            },
            // 开始时间禁用设置
            startOptions(){
                var obj={disabledDate:null};
                if(this.form.endtime){
                    obj.disabledDate=(time)=>{
                        return time.getTime() > new Date(this.form.endtime) || time.getTime() < Date.now();
                    }
                }else{
                    obj.disabledDate=(time)=>{
                        return time.getTime() < new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate()).getTime();
                    }
                }
                return obj;
            },

            
            // 结束时间禁用设置
            endOptions(){
                var obj={disabledDate:null};
                if(this.form.starttime){
                    obj.disabledDate=(time)=>{
                        return time.getTime() < new Date(this.form.starttime) - 86400000;
                    }
                }else{
                    obj.disabledDate=(time)=>{
                        return time.getTime() < new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate()).getTime();
                    }
                }
                return obj;
            },
        },
    };
</script>
<style lang="scss">
    .countries-box {
        .title-box {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: bottom;

            .detail-title {
                padding: 0 20px;
                height: 40px;
                border-top: 1px solid #e5e5e5;
                border-right: 1px solid #e5e5e5;
                border-left: 1px solid #e5e5e5;
                text-align: center;
                line-height: 40px;
                color: #409EFF;
                font-size: 14px;
            }

            .save-box {
                display: flex;
                width: calc(100% - 126px);
                flex-direction: row;
                justify-content: flex-end;
                border-bottom: 1px solid #e5e5e5;
                align-items: flex-end;
                height: 40px;

                .publish {
                    width: 100px;
                    height: 30px;
                    line-height: 30px;
                    padding: 0;
                    margin-bottom: 12px;
                }

                .save {
                    width: 100px;
                    height: 30px;
                    line-height: 30px;
                    padding: 0;
                    margin-bottom: 12px;
                }
            }
        }

        .commonTitle {
            height: 48px;
            background-color: #f9f9f9;
            border: solid 1px #e5e5e5;
            font-size: 16px;
            color: #111111;
            line-height: 48px;
            margin: 32px 0 19px;
            padding-left: 23px;
        }

        .commonTitleIcon::before {
            content: "*";
            font-size: 12px;
            color: #f56c6c;
            display: inline-block;
        }

        .one-ruleForm {
            position: relative;

            .next-button {
                position: absolute;
                right: 0;
                top: -70px;
            }

            >.el-form-item {
                margin-bottom: 30px !important;
            }
        }

        .tableBox {
            width: 97%;
            margin: 0 auto;
        }

        .addCourse {
            height: 38px;
            border: solid 1px #e5e5e5;
            text-align: center;
            line-height: 38px;
            font-size: 14px;
            color: #409EFF;
            // color: #f75959;
            border-top: none;
            cursor: pointer;
        }

        .uploadBox {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-items: flex-start;
            margin-bottom: 15px;

            .upload1 {
                width: 50%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;

                .tit::before {
                    content: "*";
                    color: #ff0000;
                }

                .tit {
                    min-width: 86px;
                    margin-right: 55px;
                    color: #666666;
                    font-size: 16px;
                }

                .tips {
                    margin-top: 15px;
                    font-size: 14px;
                    color: #999999;
                    display: block;
                }
            }
        }

        .detailImg {
            margin-top: 40px;
            padding-bottom: 150px;
            display: flex;
            flex-direction: row;

            .tit {
                min-width: 86px;
                margin-right: 50px;
            }

            .tit::before {
                content: "*";
                color: #ff0000;
            }
            .tips {
                margin-top: 15px;
                font-size: 14px;
                color: #999999;
                display: block;
            }
        }

        .pageLocation {
            position: absolute;
            left: 10px;
            bottom: 22px;
            display: flex;
            flex-direction: row;
            align-items: center;
        }

        .with-unit {
            position: relative;
            i {
                width: 30px;
                text-align: center;
                position: absolute;
                right: 80px;
                top: 0;
                line-height: 40px;
                font-size: 14px;
                font-style: normal;
                color: #999999;
            }
        }
    }


    .hide .el-upload--picture-card {
        display: none;
    }
</style>